export const GETBRANDMENU_SUCCESS = "GETBRANDMENU_SUCCESS";
export const GETBRANDMENU_ERROR = "GETBRANDMENU_ERROR";

export const ADDBRANDMENU_SUCCESS = "ADDBRANDMENU_SUCCESS";
export const ADDBRANDMENU_ERROR = "ADDBRANDMENU_ERROR";

export const UPDATEBRANDMENU_SUCCESS = "UPDATEBRANDMENU_SUCCESS";
export const UPDATEBRANDMENU_ERROR = "UPDATEBRANDMENU_ERROR";

export const CHANGEACTION_SUCCESS = "CHANGEACTION_SUCCESS";
export const CHANGEACTION_ERROR = "CHANGEACTION_ERROR";

